export default __webpack_public_path__ + "static/media/kvm_server.f5ab958c.jpg";